import { Injectable, inject } from '@angular/core';
// import { Actions, createEffect, Effect, ofType } from '@ngrx/effects';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, from, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { Helper } from "../../shared/services/Helper.service";
import {
    ActionTypes,
    GetAllItemCategory,
    GetAllItemCategorySuccess,
    GetAllItemCategoryError,
    GetAllCollectionType,
    GetAllCollectionTypeSuccess,
    GetAllCollectionTypeError,
    GetAllProductType,
    GetAllProductTypeSuccess,
    GetAllProductTypeError,
    GetAllOccasionType,
    GetAllOccasionTypeSuccess,
    GetAllOccasionTypeError,
    GetFestiveOccasionName,
    GetFestiveOccasionNameSuccess,
    GetFestiveOccasionNameError,
    GetAllFestiveOccasionItems,
    GetAllFestiveOccasionItemsSuccess,
    GetAllFestiveOccasionItemsError
} from "./ItemCategory.actions";
import { EmptyCriteria } from "../../shared/interfaces/CriteriaModel";
import { ItemCategoryService } from 'src/app/shared/services/itemCategory.service';

@Injectable()
export class ItemCategoryEffects {

    // @Effect()
    // GetAllItemCategory$ = this.actions$.pipe(
    GetAllItemCategory$ = createEffect(() => {
        return inject(Actions).pipe(
            ofType(ActionTypes.GetAllItemCategory),
            map((action: GetAllItemCategory) => action.payload),
            mergeMap((payload) => {
                return this.ItemCategoryService.GetAllItemCategory(payload).pipe(
                    map((response) => {
                        return new GetAllItemCategorySuccess(response);
                    }),
                    catchError((error) => of(new GetAllItemCategoryError(error)))
                )
            })
        )
    });
    // );

    // @Effect({ dispatch: false })
    // GetAllItemCategorySuccess$ = this.actions$.pipe(
    GetAllItemCategorySuccess$ = createEffect(() => {
        return inject(Actions).pipe(
            ofType(ActionTypes.GetAllItemCategorySuccess),
            map((action: GetAllItemCategorySuccess) => action.payload),
            mergeMap((payload) => {
                return of();
            })
        )
    }, { dispatch: false });
    // );

    // @Effect({ dispatch: false })
    // GetAllItemCategoryError$ = this.actions$.pipe(
    GetAllItemCategoryError$ = createEffect(() => {
        return inject(Actions).pipe(
            ofType(ActionTypes.GetAllItemCategoryError),
            map((action: GetAllItemCategoryError) => action.payload),
            mergeMap((payload) => {
                this.helper.Error$(payload);
                return of(null)
            })
        )
    }, { dispatch: false });
    // );

    // @Effect()
    // GetAllCollectionType$ = this.actions$.pipe(
    GetAllCollectionType$ = createEffect(() => {
        return inject(Actions).pipe(
            ofType(ActionTypes.GetAllCollectionType),
            map((action: GetAllCollectionType) => action.payload),
            mergeMap((payload) => {
                return this.ItemCategoryService.GetAllCollectionType(payload).pipe(
                    map((response) => {
                        return new GetAllCollectionTypeSuccess(response);
                    }),
                    catchError((error) => of(new GetAllCollectionTypeError(error)))
                )
            })
        )
    });
    // );

    // @Effect({ dispatch: false })
    // GetAllCollectionTypeSuccess$ = this.actions$.pipe(
    GetAllCollectionTypeSuccess$ = createEffect(() => {
        return inject(Actions).pipe(
            ofType(ActionTypes.GetAllCollectionTypeSuccess),
            map((action: GetAllCollectionTypeSuccess) => action.payload),
            mergeMap((payload) => {
                return of();
            })
        )
    }, { dispatch: false });
    // );

    // @Effect({ dispatch: false })
    // GetAllCollectionTypeError$ = this.actions$.pipe(
    GetAllCollectionTypeError$ = createEffect(() => {
        return inject(Actions).pipe(
            ofType(ActionTypes.GetAllCollectionTypeError),
            map((action: GetAllCollectionTypeError) => action.payload),
            mergeMap((payload) => {
                this.helper.Error$(payload);
                return of(null)
            })
        )
    }, { dispatch: false });
    // );

    // @Effect()
    // GetAllProductType$ = this.actions$.pipe(
    GetAllProductType$ = createEffect(() => {
        return inject(Actions).pipe(
            ofType(ActionTypes.GetAllProductType),
            map((action: GetAllProductType) => action.payload),
            mergeMap((payload) => {
                return this.ItemCategoryService.GetAllProductType(payload).pipe(
                    map((response) => {
                        return new GetAllProductTypeSuccess(response);
                    }),
                    catchError((error) => of(new GetAllProductTypeError(error)))
                )
            })
        )
    });
    // );

    // @Effect({ dispatch: false })
    // GetAllProductTypeSuccess$ = this.actions$.pipe(
    GetAllProductTypeSuccess$ = createEffect(() => {
        return inject(Actions).pipe(
            ofType(ActionTypes.GetAllProductTypeSuccess),
            map((action: GetAllProductTypeSuccess) => action.payload),
            mergeMap((payload) => {
                return of();
            })
        )
    }, { dispatch: false });
    // );

    // @Effect({ dispatch: false })
    // GetAllProductTypeError$ = this.actions$.pipe(
    GetAllProductTypeError$ = createEffect(() => {
        return inject(Actions).pipe(
            ofType(ActionTypes.GetAllProductTypeError),
            map((action: GetAllProductTypeError) => action.payload),
            mergeMap((payload) => {
                this.helper.Error$(payload);
                return of(null)
            })
        )
    }, { dispatch: false });
    // );


    // @Effect()
    // GetAllOccasionType$ = this.actions$.pipe(
    GetAllOccasionType$ = createEffect(() => {
        return inject(Actions).pipe(
            ofType(ActionTypes.GetAllOccasionType),
            map((action: GetAllOccasionType) => action.payload),
            mergeMap((payload) => {
                return this.ItemCategoryService.GetAllOccasionType(payload).pipe(
                    map((response) => {
                        return new GetAllOccasionTypeSuccess(response);
                    }),
                    catchError((error) => of(new GetAllOccasionTypeError(error)))
                )
            })
        )
    });
    // );

    // @Effect({ dispatch: false })
    // GetAllOccasionTypeSuccess$ = this.actions$.pipe(
    GetAllOccasionTypeSuccess$ = createEffect(() => {
        return inject(Actions).pipe(
            ofType(ActionTypes.GetAllOccasionTypeSuccess),
            map((action: GetAllOccasionTypeSuccess) => action.payload),
            mergeMap((payload) => {
                return of();
            })
        )
    }, { dispatch: false });
    // );

    // @Effect({ dispatch: false })
    // GetAllOccasionTypeError$ = this.actions$.pipe(
    GetAllOccasionTypeError$ = createEffect(() => {
        return inject(Actions).pipe(
            ofType(ActionTypes.GetAllOccasionTypeError),
            map((action: GetAllOccasionTypeError) => action.payload),
            mergeMap((payload) => {
                this.helper.Error$(payload);
                return of(null)
            })
        )
    }, { dispatch: false });
    // );

    // @Effect()
    // GetFestiveOccasionName$ = this.actions$.pipe(
    GetFestiveOccasionName$ = createEffect(() => {
        return inject(Actions).pipe(
            ofType(ActionTypes.GetFestiveOccasionName),
            map((action: GetFestiveOccasionName) => action.payload),
            mergeMap((payload) => {
                return this.ItemCategoryService.GetFestiveOccasionName(payload.festiveOccasionName).pipe(
                    map((response) => {
                        return new GetFestiveOccasionNameSuccess(response);
                    }),
                    catchError((error) => of(new GetFestiveOccasionNameError(error)))
                )
            })
        )
    });
    // );

    // @Effect({ dispatch: false })
    // GetFestiveOccasionNameSuccess$ = this.actions$.pipe(
    GetFestiveOccasionNameSuccess$ = createEffect(() => {
        return inject(Actions).pipe(
            ofType(ActionTypes.GetFestiveOccasionNameSuccess),
            map((action: GetFestiveOccasionNameSuccess) => action.payload),
            mergeMap((payload) => {
                return of();
            })
        )
    }, { dispatch: false });
    // );

    // @Effect({ dispatch: false })
    // GetFestiveOccasionNameError$ = this.actions$.pipe(
    GetFestiveOccasionNameError$ = createEffect(() => {
        return inject(Actions).pipe(
            ofType(ActionTypes.GetFestiveOccasionNameError),
            map((action: GetFestiveOccasionNameError) => action.payload),
            mergeMap((payload) => {
                this.helper.Error$(payload);
                return of(null)
            })
        )
    }, { dispatch: false });
    // );


    // @Effect()
    // GetAllFestiveOccasionItems$ = this.actions$.pipe(
    GetAllFestiveOccasionItems$ = createEffect(() => {
        return inject(Actions).pipe(
            ofType(ActionTypes.GetAllFestiveOccasionItems),
            map((action: GetAllFestiveOccasionItems) => action.payload),
            mergeMap((payload) => {
                return this.ItemCategoryService.GetAllFestiveOccasionItems(payload).pipe(
                    map((response) => {
                        return new GetAllFestiveOccasionItemsSuccess(response);
                    }),
                    catchError((error) => of(new GetAllFestiveOccasionItemsError(error)))
                )
            })
        )
    });
    // );

    // @Effect({ dispatch: false })
    // GetAllFestiveOccasionItemsSuccess$ = this.actions$.pipe(
    GetAllFestiveOccasionItemsSuccess$ = createEffect(() => {
        return inject(Actions).pipe(
            ofType(ActionTypes.GetAllFestiveOccasionItemsSuccess),
            map((action: GetAllFestiveOccasionItemsSuccess) => action.payload),
            mergeMap((payload) => {
                return of();
            })
        )
    }, { dispatch: false });
    // );

    // @Effect({ dispatch: false })
    // GetAllFestiveOccasionItemsError$ = this.actions$.pipe(
    GetAllFestiveOccasionItemsError$ = createEffect(() => {
        return inject(Actions).pipe(
            ofType(ActionTypes.GetAllFestiveOccasionItemsError),
            map((action: GetAllFestiveOccasionItemsError) => action.payload),
            mergeMap((payload) => {
                this.helper.Error$(payload);
                return of(null)
            })
        )
    }, { dispatch: false });
    // );


    constructor(
        private actions$: Actions,
        private helper: Helper,
        private ItemCategoryService: ItemCategoryService
    ) {
    }
}
